import { motion } from "framer-motion";
import { SERVICES } from "../lib/site";

export default function Services() {
  return (
    <section
      id="services"
      className="py-24 lg:py-32 border-t border-[#E5E5E0] bg-[#FFFFFF]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <span className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#CC5500]">
              (Services)
            </span>
            <h2 className="mt-4 font-serif-display text-4xl lg:text-6xl tracking-tightest text-[#1C1C1A] leading-[0.95]">
              What we paint,
              <br />
              and how we paint it.
            </h2>
          </div>
          <p className="lg:max-w-sm font-sans-body text-base text-[#4A4A46] leading-relaxed">
            Five focused service lines. Same crew. Same standard — whether it's a
            powder room or a 12,000 sq ft warehouse.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 grid-flow-row-dense gap-4">
          {SERVICES.map((s, i) => {
            const span = [
              "md:col-span-2 lg:col-span-3 lg:row-span-2",
              "md:col-span-1 lg:col-span-3",
              "md:col-span-2 lg:col-span-2",
              "md:col-span-1 lg:col-span-2",
              "md:col-span-3 lg:col-span-2",
            ][i];
            return (
              <motion.div
                key={s.key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.55, delay: 0.06 * i }}
                className={`${span} group relative border border-[#E5E5E0] bg-[#F5F5F0] p-8 lg:p-10 transition-all duration-300 hover:bg-[#1C1C1A] hover:border-[#1C1C1A] cursor-default min-h-[200px] flex flex-col justify-between`}
                data-testid={`service-card-${s.key}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-sans-body text-xs uppercase tracking-[0.25em] text-[#4A4A46] group-hover:text-[#CC5500] transition-colors duration-300">
                    {s.num}
                  </span>
                </div>
                <div className="mt-12">
                  <h3 className="font-serif-display text-3xl lg:text-4xl tracking-tighter text-[#1C1C1A] group-hover:text-[#F5F5F0] transition-colors duration-300">
                    {s.title}
                  </h3>
                  <p className="mt-3 font-sans-body text-sm text-[#4A4A46] group-hover:text-[#E5E5E0] transition-colors duration-300 max-w-md leading-relaxed">
                    {s.blurb}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
